import {combineReducers} from 'redux';
import * as ACTIONS from '../actions/home_action';
import Store from '../script/store';
import Utils from '../script/utils';

let initUserLogin = Store.get('userLogin') || false;

const loadingStatus = (state = false, action) => {
  switch (action.type) {
    case ACTIONS.SET_LOADING_STATUS:
      return action.loadingStatus;
    default:
      return state;
  }
}

const windowSizeChange = function(state = {windowId:'', flag:false}, action){
  switch (action.type) {
    case ACTIONS.SET_WINDOW_SIZE_CHANGE:
      return action.windowSizeChange;
    default:
      return state;
  }
}

var desktopType = function(state = 'router', action){
  switch (action.type) {
    case ACTIONS.SET_DESKTOP_TYPE:
      return action.desktopType;
    default:
      return state;
  }
}

var userLogin = function(state = true, action){
  switch (action.type) {
    case ACTIONS.SET_USER_LOGIN:
      return action.userLogin;
    default:
      return state;
  }
}

var errorMsg = function(state = '', action){
  switch (action.type) {
    case ACTIONS.SET_ERROR_MSG:
      return action.errorMsg;
    default:
      return state;
  }
}

var dialogMsg = function(state = {}, action){
  switch (action.type) {
    case ACTIONS.SET_DIALOG_MSG:
      return action.dialogMsg;
    default:
      return state;
  }
}

var cySize = function(state = '', action){
  switch (action.type) {
    case ACTIONS.SET_CYSIZE:
      return action.cySize;
    default:
      return state;
  }
}

var vpntopologyData = function(state = [], action){
  switch (action.type) {
    case ACTIONS.SET_VPNTOPOLOGYDATA:
      return action.vpntopologyData;
    default:
      return state;
  }
}

var vpntopologyStatus = function(state = [], action){
  switch (action.type) {
    case ACTIONS.SET_VPNTOPOLOGYSTATUS:
      return action.vpntopologyStatus;
    default:
      return state;
  }
}

var managerServerIP = function(state = '', action){
  switch (action.type) {
    case ACTIONS.SET_MANAGER_SERVER_IP:
      return action.managerServerIP;
    default:
      return state;
  }
}

var managerServerPort = function(state = '', action){
  switch (action.type) {
    case ACTIONS.SET_MANAGER_SERVER_PORT:
      return action.managerServerPort;
    default:
      return state;
  }
}

var proxyServerList = function(state = [], action){
  switch (action.type) {
    case ACTIONS.SET_PROXY_SERVER_LIST:
      return action.proxyServerList;
    default:
      return state;
  }
}

var managerServerSessionId = function(state = '', action){
  switch (action.type) {
    case ACTIONS.SET_MANAGER_SERVER_SESSIONID:
      return action.managerServerSessionId;
    default:
      return state;
  }
}

var hintDialogInfo = function(state = '', action){
  switch (action.type) {
    case ACTIONS.SET_HINT_DIALOG_INFO:
      return action.hintDialogInfo;
    default:
      return state;
  }
}

var windowSize = function(state = '', action){
  switch (action.type) {
    case ACTIONS.SET_WINDOW_SIZE:
      return action.windowSize;
    default:
      return state;
  }
}

var dashboardItems = function(state = ['systemStatus', 'resourceMonitor'], action){
  switch (action.type) {
    case ACTIONS.SET_DASHBOARD_ITEMS:
      return action.dashboardItems;
    default:
      return state;
  }
}

var subSideCollapsed = function(state = false, action) {
  switch (action.type) {
    case ACTIONS.SET_SUBSIDECOLLAPSED:
      return action.subSideCollapsed;
    default:
      return state;
  }
}

var breakPoint = function(state = Utils.queryBreakPoint() || 'showLong', action){
  switch (action.type) {
    case ACTIONS.SET_BREAKPOINT:
      return action.breakPoint;
    default:
      return state;
  }
}

const homeReducer = combineReducers({
    loadingStatus,
    windowSizeChange,
    desktopType,
    userLogin,
    errorMsg,
    dialogMsg,
    cySize,
    vpntopologyData,
    vpntopologyStatus,
    managerServerIP,
    managerServerPort,
    proxyServerList,
    managerServerSessionId,
    hintDialogInfo,
    windowSize,
    dashboardItems,
    subSideCollapsed,
    breakPoint
})

export default homeReducer;
